import { PardotCompletionActionReferencesTab } from '@periscopes/general/pardot-completion-actions';
import { PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import { PeriscopeBodyComponent } from '@periscopes/types';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';

import { PardotEmailTemplateFieldsTab, PardotEmailTemplateMetadataTab } from '.';
import { PeriscopeMenuTabs, PeriscopeTabArea } from '@periscopes/general';

export const PardotEmailTemplateScope: PeriscopeBodyComponent = ({ data, index }) => {
	const { sonarObjectId, relatedCounts } = data;

	return (
		<PeriscopeMenuTabs>
			<PeriscopeTabArea
				key={ PERISCOPE_TAB_TYPES.METADATA }
				tab={ PERISCOPE_TAB_TYPES.METADATA }>
				<PardotEmailTemplateMetadataTab sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.PardotField ] ?? 0 }
				key={ PERISCOPE_TAB_TYPES.FIELDS }
				requiresCount
				tab={ PERISCOPE_TAB_TYPES.FIELDS }>
				<PardotEmailTemplateFieldsTab
					index={ index }
					sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts.pardotCompletionActionReference ?? 0 }
				key={ PERISCOPE_TAB_TYPES.COMPLETION_ACTION_REFERENCES }
				requiresCount
				tab={ PERISCOPE_TAB_TYPES.COMPLETION_ACTION_REFERENCES }>
				<PardotCompletionActionReferencesTab
					index={ index }
					sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
		</PeriscopeMenuTabs>
	);
};
